/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TableSimple.vue?vue&type=template&id=44c1909e&"
import script from "./TableSimple.vue?vue&type=script&lang=js&"
export * from "./TableSimple.vue?vue&type=script&lang=js&"
import style0 from "./TableSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports